import { render } from "./FormItem.vue?vue&type=template&id=54a69d5b&ts=true"
import script from "./FormItem.vue?vue&type=script&lang=ts"
export * from "./FormItem.vue?vue&type=script&lang=ts"

import "./FormItem.vue?vue&type=style&index=0&id=54a69d5b&lang=scss"

import exportComponent from "/fides/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__